import React, { useMemo, useState } from "react";
import { Box } from "@mui/material";
import { StriimTypography } from "@striim/striim-ui";
import { List, RowComponentProps } from "react-window";
import WithTheme from "src/generic/theme/theme";
import TablesListComponent from "./tables-list";
import { sxStyles } from "./table-selection-data-table.styles";
import type { SchemaModel } from "../types";


interface TableSelectionTableProps {
    schemas: SchemaModel[];
    whatIsTable: string;
}

const TableSelectionTable: React.FC<TableSelectionTableProps> = ({ schemas, whatIsTable }) => {
    const [activeSchemaIndex, setActiveSchemaIndex] = useState(0);

    const SchemaItems = ({
        index,
        style,
        schemas
    }: RowComponentProps<{
        schemas: SchemaModel[];
    }>) => {
        const schema = schemas[index];
        const schemaDisplayName = schema.attributes.schemaDisplayName;
        const isSchemaActive = index === activeSchemaIndex;

        return (
            <Box
                style={style}
                onClick={() => {
                    setActiveSchemaIndex(index);
                }}
                sx={sxStyles.schemaItemContainer(isSchemaActive)}
                data-testid={`schema-item-${schemaDisplayName}`}
            >
                <StriimTypography
                    variant="body4"
                    color={isSchemaActive ? "primary.700" : "greyscale.700"}
                >
                    {schemaDisplayName}
                </StriimTypography>
            </Box>
        );
    };

    const SchemasListMemoized = useMemo(
        () => (
            <Box sx={sxStyles.schemaContainer}>
                <List
                    rowComponent={SchemaItems}
                    rowHeight={45}
                    rowCount={schemas.length}
                    rowProps={{ schemas }}
                    height={600}
                    width="100%"
                />
            </Box>
        ),
        [schemas, activeSchemaIndex]
    );

    const TablesListMemoized = useMemo(
        () => <TablesListComponent whatIsTable={whatIsTable} schemas={schemas} activeSchemaIndex={activeSchemaIndex} />,
        [schemas, activeSchemaIndex, whatIsTable]
    );

    return (
        <Box sx={sxStyles.container}>
            {SchemasListMemoized}
            {TablesListMemoized}
        </Box>
    );
};

export default WithTheme(TableSelectionTable);
